'use client';

import React, { useRef } from 'react';
import { Form } from 'react-bootstrap';
import { format } from 'date-fns';
import DateRangePickerExample from '../../../pages/house-offer/request/DateRangePickerExample';
import DateRange from '../../lakeview/daterange/DateRange';

const DateRangePickerField = ({
  field,
  formData,
  handleFieldChange,
  defineClass,
  calculateReadOnly,
  fromLabel,
  toLabel,
}) => {
  const today = new Date();
  const wrapperRef = useRef();

  field.minDateNow = true;

  const minDate = field.minDateNow
    ? today
    : field.minDate
      ? new Date(field.minDate)
      : undefined;

  const startDate = formData[field.startField]
    ? new Date(formData[field.startField])
    : null;

  const endDate = formData[field.endField]
    ? new Date(formData[field.endField])
    : null;

  const handleClear = () => {
    handleFieldChange(field.startField, '', field.endField, '');
  };

  return (
    <Form.Group
      className={`form-group ${field.hideOnPrint ? 'print-hide' : ''}`}
    >
      {/* Label */}
      {field.label && (
        <Form.Label
          htmlFor={field.startField}
          onClick={() => {
            if (wrapperRef.current) {
              wrapperRef.current.click();
            }
          }}
          className="mb-2"
          style={{ cursor: 'pointer' }}
        >
          {field.label}
        </Form.Label>
      )}

      {/* Input */}
      <DateRange
        start={startDate}
        end={endDate}
        onDateRangeUpdated={(dates) => {
          const [start, end] = dates;

          handleFieldChange(
            field.startField,
            start ? format(start, 'yyyy-MM-dd') : '',
            field.endField,
            end ? format(end, 'yyyy-MM-dd') : '',
          );
        }}
        onClear={handleClear}
        disabled={calculateReadOnly(field)}
        ref={wrapperRef}
        excludedDates={field.excludedDates}
        excludedStartDates={field.excludedStartDates}
        excludedEndDates={field.excludedEndDates}
        minDate={minDate}
        fromLabel={fromLabel}
        toLabel={toLabel}
      />
    </Form.Group>
  );
};

export default DateRangePickerField;
